<!-- Screen-only action: it sits outside #dataToPrint, so it never shows up in the generated PDF. -->
<div class="bm-actions">
  <button
    mat-fab
    extended
    type="button"
    class="bm-print"
    (click)="onSubmit()"
    [disabled]="disableSubmit"
    [attr.aria-label]="isCompleted ? 'Imprimir presupuesto' : 'Guardar e imprimir presupuesto'"
  >
    <mat-icon>print</mat-icon>
    {{ isCompleted ? 'Imprimir' : 'Guardar e imprimir' }}
  </button>
</div>
<div id="dataToPrint" #contentToPrint class="container budget-general">
  <div class="row budget-head" style="border: 1px solid #c0bfbf">
    <div class="col-6 d-flex align-items-center">
      <img src="assets/images/Lagune.png" alt="" class="lagune-logo" />
    </div>
    <div class="col-6 d-flex flex-column justify-content-center align-items-start">
      <span class="presupuesto font-18">PRESUPUESTO</span>
      <span class="duration">VALIDO POR 2 DIAS</span>
      <span class="date">Fecha:
        <input type="text" name="day" class="font-16" [(ngModel)]="day" readonly />
        <input type="text" name="month" class="font-16" [(ngModel)]="month" readonly />
        <input type="text" name="year" class="font-16" [(ngModel)]="year" readonly />
      </span>
    </div>
  </div>
  <div class="row d-flex align-items-center budget-client">
    <div class="col-5">
      <span class="client-budget">CLIENTE:
      <input type="text" class="name font-14" name="clientName" [value]="budget.clientName" readonly /></span>
    </div>
    <div class="col-3">
      <span class="client-budget">TELEFONO:
        <input type="text" class="phone font-14" name="clientPhoneNumber" [value]="budget.clientPhoneNumber"
        readonly /></span>
      </div>
      <div class="col-4">
        <span class="client-budget">CIUDAD:
        <input type="text" class="city font-14" name="clientCity" [value]="budget.clientCity" readonly /></span>
      </div>
    </div>
    <div class="row budget-body">
      <div class="col-4 body-left">
        <div class="mt-2 font-12"><span>LINEA/MODELO</span></div>
        <div class="mt-1 mb-2 font-28 lagune-logo2">
          <img src="assets/images/Lagune_2.png" alt="" />
        </div>
        <div class="model font-32">
          <span name="model">{{ budget.poolModel.model }}</span>
        </div>
        <div class="font-11 mt-3">
          <div class="row mb-0">
            <div class="col d-flex flex-wrap justify-content-end">
              <p class="mb-0" name="length">
                Largo: {{ budget.poolModel.length }}m
              </p>
            </div>
            |
            <div class="col d-flex justify-content-start">
              <p class="mb-0" name="width">
                Ancho: {{ budget.poolModel.width }}m
              </p>
            </div>
          </div>
          <div class="row mb-0 justify-content-center">
            <div class="col d-flex flex-wrap justify-content-end pe-0">
              <p class="mb-0">Profundidad:</p>
            </div>
            <div class="col d-flex justify-content-start ps-0">
              <p class="mb-0" name="depthOne">
                {{ budget.poolModel.depthOne }}m a
              </p>
              <p class="mb-0" name="depthTwo">
                {{ budget.poolModel.depthTwo }}m
              </p>
            </div>
          </div>
          <div class="row mb-0">
            <div class="col">
              <p class="mb-0" name="solariumLength">
                Solarium húmedo: {{ budget.poolModel.solariumLength }}m<sup>2</sup>
              </p>
            </div>
          </div>
          <div class="line-long mt-2 mb-1"></div>
          <div class="mid-left-body">
            <div class="font-14 d-flex flex-wrap align-content-center" style="height: 50px">
              <div class="row w-100">
                <div class="col-6 d-flex align-items-center" style="color: #7f7f7f">
                  <b>Lista $</b>
                </div>
                <div class="col-6">
                  <input type="text" class="font-18 pt-2" placeholder="999.999" [value]="budget.listPrice | number : '1.0-0'" readonly />
                </div>
              </div>
            </div>

            <div class="font-14 d-flex flex-wrap align-content-center" style="height: 50px">
              <div class="row w-100">
                <div class="col-6 d-flex align-items-center" style="color: #7f7f7f">
                  <b>Contado $</b>
                </div>
                <div class="col-6">
                  <input type="text" class="font-18" placeholder="999.999" [value]="budget.cashPrice | number : '1.0-0'" readonly />
                </div>
              </div>
            </div>
            <div class="short-line mt-2 mb-2"></div>
            <div class="font-16 mb-2" [formGroup]="interestForm">
              <h2 class="ms-2 mb-0 font-16">FINANCIACION</h2>
              <div class="entrega mt-2 d-flex justify-content-center">
                <mat-form-field appearance="fill">
                  <p class="font-12">Entrega mínima en efectivo de</p>
                  <span class="font-18">$<input #numeroInput class="sin-botones" matInput type="number"
                    formControlName="minimumCashDownPayment" (keydown)="validateOnlyPositiveNumbers($event)"
                  (keyup)="validateOnlyPositiveNumbers($event)" [readonly]="isCompleted" /></span>
                </mat-form-field>
              </div>
              <div class="d-flex mb-1 justify-content-center">
                <div class="mt-3 me-1">
                  <img src="assets/images/visa.png" alt="Visa" />
                </div>
                <div class="mt-3 ms-1">
                  <img src="assets/images/master.png" alt="Visa" />
                </div>
              </div>
              @for (plan of currentInterestRates; track plan) {
                <div>
                  @if (plan.isActive) {
                    <div class="plan mt-1 mb-1">
                      <div class="col-6">
                        <span class="font-11"><b class="font-16">{{ plan.installments }} </b> Cuotas de
                      $</span>
                    </div>
                    <div class="col-5">
                      <input type="text" placeholder="999.999" name="cuotasValue" [value]="payoutEstimator(plan) | number : '1.2-2'"
                        readonly />
                      </div>
                    </div>
                  }
                </div>
              }
            </div>
          </div>
          <div class="row vendor-data h-auto">
            <div class="col-4 font-12"><b>VENDEDOR: </b></div>
            <div class="col-8">
              <input type="text" class="mt-2 mb-1" placeholder="Nombre Apellido" [value]="budget.salesPersonName"
                readonly />
              </div>
              <div class="col-4 font-12"><b>CONTACTO: </b></div>
              <div class="col-8">
                <input type="text" class="mt-2 mb-1" placeholder="+54 000 0000000" [value]="budget.salesPersonPhoneNumber"
                  readonly />
                </div>
                <div class="col-4 font-12"><b>DIRECCION: </b></div>
                <div class="col-8">
                  <input type="text" class="mt-2 mb-1" placeholder="Calle y número" [value]="budget.standStreet" readonly />
                </div>
                <div class="col-4 font-12"><b>TELEFONO: </b></div>
                <div class="col-8">
                  <input type="text" class="mt-2 mb-1" placeholder="+54 000 0000000" [value]="budget.standPhoneNumber"
                    readonly />
                  </div>
                </div>
              </div>
            </div>
            <div class="col-8 body-right d-flex flex-column">
              <div class="row d-flex standar">
                <div class="ms-2">
                  <h2 class="font-14 mt-3 mb-1">COMBO</h2>
                  <ul class="font-11 two-column-list mb-0 d-flex">
                    @for (item of budget.poolModel.combo; track item) {
                      <li>
                        <div class="row">
                          <div class="col-4 d-flex flex-wrap align-content-center">
                            {{ item.description }}
                          </div>
                          <div class="offset-1 col-6 no-install">
                            <span><b>NO REQUIERE INSTALACION</b></span>
                          </div>
                        </div>
                        <!-- <ul class="sub-list" *ngIf="item.detail.length > 0">
                        <li *ngFor="let subItem of item.detail">
                          {{ subItem.description }}
                        </li>
                      </ul> -->
                    </li>
                  }
                </ul>
              </div>
            </div>
            <div class="row line mt-3 mb-3"></div>
            <div class="row ms-2">
              <h2 class="font-14 mt-2">ACCESORIOS OPCIONALES</h2>
              <div class="font-11 midle-right">
                <div class="d-flex justify-content-between mb-1">
                  <ul class="w-100 pl-0">
                    @for (accessory of budget.optionalAccessories; track accessory) {
                      <li class="d-flex justify-content-between mb-1">
                        <div class="col-9">
                          <span><b>{{ accessory.item }}</b></span>
                        </div>
                        <div class="col-3">
                          <input class="me-4" type="text" name="optionalAccesory" placeholder="$ 000.00"
                    [ngModel]="getAccessoryModel(accessory)" [readonly]="!accessory.isEditable || isCompleted" (change)="
                      accesoryModified(accessory.id.toString(), accessory.price)
                    " />
                          </div>
                        </li>
                      }
                    </ul>
                  </div>
                </div>
              </div>
              <div class="row d-flex flex-grow-1 align-items-end">
                <img class="publicity" src="assets/images/Lagune_3.jpg" alt="" />
              </div>
            </div>
          </div>
          <div class="row" style="border: 1px solid #c0bfbf">
            <img src="assets/images/budget-foot-1.jpg" style="padding: 0" alt="footer-img" />
          </div>
        </div>